import Vue from "vue";
import Vuex from "vuex";
import EventEmitter from "events";
import { ApiClient, Store } from "../components/RedbayComponents";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";
export const storeEmitter = new EventEmitter();
export const INITIAL_DATA = "api_start";

export const store = new Vuex.Store({
  struct: debug,
  modules: {
    ...Store(),
    demo: {
      namespaced: true,
      state: {
        enabled: false
      },
      mutations: {
        enableDemo(state) {
          state.enabled = true;
        },
        disableDemo(state) {
          state.enabled = false;
        }
      },
      actions: {
        enableDemo({ commit }) {
          commit("enableDemo");
        },
        disableDemo({ commit }) {
          commit("disableDemo");
        }
      }
    }
  },
  state: {
    createdTicket: false,
    shop: null,
    breadcrumbVisible: false,
    breadcrumbPath: [],
    showRightWindow: false,
    showRightWindowOffer: false,
    searchBlock: false,
    menuVisible: "",
    notifications: []
  },
  getters: {},
  mutations: {
    initializeShop(state, initialData) {
      state.shop = { ...initialData, name: initialData["app_name"] };
      storeEmitter.emit(INITIAL_DATA, state.shop);
    },
    AddNewNotification(state, message) {
      state.notifications.push(message);
    },
    removeNotification(state, key) {
      let pom = -1;
      for (let i = 0; i < state.notifications.length; i++) {
        if (!(state.notifications[i] === undefined)) {
          if (state.notifications[i].key == key) {
            pom = i;
            break;
          }
        }
      }
      if (pom >= 0) {
        delete state.notifications[pom];
      }
    }
  },
  actions: {
    clearTicket({ state }) {
      state.createdTicket = false;
    },

    async createTicket({ state, commit }, browserParams) {
      if (!state.createdTicket) {
        let initialData = await ApiClient.createTicket(browserParams);
        commit("initializeShop", initialData);
        state.createdTicket = initialData;
      }
      return state.createdTicket;
    },

    openRightWindowOffer({ commit, state }) {
      state.showRightWindow = true;
      state.showRightWindowOffer = true;
    },

    openRightWindow({ commit, state }) {
      state.showRightWindowOffer = false;
      state.showRightWindow = true;
    },

    closeRightWindow({ commit, state }) {
      state.showRightWindow = false;
      state.showRightWindowOffer = false;
    },

    addSuccessNotification({ commit }, message) {
      commit("addSuccessNotification", "Wiadmość została wysłana");
    },

    addNotification({ commit }, message) {
      commit("AddNewNotification", message);
    },

    closeSearchBlock({ state }) {
      state.searchBlock = false;
    },

    openSearchBlock({ state }) {
      state.searchBlock = true;
    },

    emit({}, event) {
      storeEmitter.emit(event.key, event.message);
    }
  }
});



// WEBPACK FOOTER //
// ./src/state/store.js